// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__PGkVI","bigColWidth":"Table_bigColWidth__GHZKc","biggerColWidth":"Table_biggerColWidth__1Lwh3","row":"Table_row__3JDPA","col":"Table_col__-0hn6"};